import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import CustomModalFooter from 'src/components/custom_components/CustomModal/CustomModalFooter';

import { I18NextNS } from 'src/models/Language.model';

interface ServerErrorFooterProps {
  onEndSession: () => void;
}

export default function ServerErrorFooter({
  onEndSession,
}: ServerErrorFooterProps) {
  const { t } = useTranslation(I18NextNS.PAGES);

  return (
    <CustomModalFooter>
      <Button
        variant="primary"
        data-track="exam.analyzing-modal.cancel-exam"
        data-test="analyzing-modal-cancel-exam"
        data-observe
        onClick={onEndSession}
      >
        {t('newExam.cancelExam')}
      </Button>
    </CustomModalFooter>
  );
}
